export default {
    USER_ID : "user_TBNx5eXNuT4ZVhD3CHE1Y",
    TOKEN : "da157cec01c8752979b338d1fcc0b69b",
    SERVICE_ID : "gmail",
    TEMPLATE_ID : "template_6yFtiWP0",
    }